<template>
    <div class="tableHeader">
      <div :class="showTitleLine?'showTitleLineLeft':'left'" v-if="showLeft" >
        <pt-search v-if="!showTitle" v-model="searchText" :placeholder="placeholder" @searchEvent="searchEvent"></pt-search>
        <span v-if="showTitle" class="title">{{$t(title)}}</span>
        <div v-if="showTitleLine" style='flex:1;height:1px;background:#E3E3E3;margin-left: 20px;'></div>
      </div>
      <div class="right" :class="showLeft ?'':'showLeftClass'">
        <div class="select-div" v-if="$slots.select" :style="showAdd?'':'padding-right:0px;'">
          <slot name="select">
          </slot>
        </div>
        <div class="right-opration" v-if="$slots.select && showLine"></div>
        <div class="add-btn" v-if="showAdd">
          <a-button type="primary" shape="circle" icon="plus" @click.stop="clickEvent"></a-button>
        </div>
      </div>

    </div>
</template>

<script>
  export default {
    name: 'ptTableHeader',
    props:{
      placeholder:{
        type:String,
      },
      showTitle:{
        type:Boolean,
        default:false,
      },
      showAdd:{
        type:Boolean,
        default:true,
      },
      showLeft:{
        type:Boolean,
        default:true,
      },
      text:{
        type:String,
        default:null,
      },
      showLine:{
        type:Boolean,
        default:true,
      },
      searchValue:{
        type:String,
        default:undefined,
      },
      showTitleLine:{
        type:Boolean,
        default:false,
      }
    },
    computed:{
      title(){
        return this.text?this.text:this.$route.meta.title
      }
    },
    data() {
      return {
        searchText:'',
      }
    },
    mounted() {

    },
    watch: {
      'searchValue'(newValue) {
        this.searchText = newValue
      }

    },
    methods: {
      searchEvent(){
        this.$emit('search',this.searchText)
      },
      clickEvent(){
        console.log('add - emp')
        this.$emit('add')
      },
    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";
  .tableHeader{
    display: flex;
    justify-content: space-between;
    width: 100%;
    .left{
      flex: auto;
    }
    .showTitleLineLeft{
      flex: auto;
      display: flex;
      align-items: center;
    }
    .right{
      display: flex;
    }
    .showLeftClass{
      flex: auto;
      justify-content: flex-end;
    }
    .right-opration{
      min-width: 60px;
      border-bottom: 1px solid @border-color;
    }
    .title{
      font-size: 18px;
      color: @text-color-3;
      white-space: nowrap;
      padding-right: 8px;
    }
    .select-div{
      font-size: 12px;
      color: @text-color-9;
      padding-right: 30px;
      position: relative;
      >span{
        font-size: 14px;
        color: #999999;
        padding-left: 30px;
        padding-right: 15px;
      }
    }
    .add-btn{
      position: absolute;
      right: 24px;
      top: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        color: @primary-6;
        box-shadow: 0 7px 9px 0 rgba(59,46,38,0.42);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      button:hover{
        color: @primary-6;
      }
      /deep/ .anticon{
        line-height: 0;
      }
    }
  }
</style>